export * from './adhoc-details.component';